import type { FaireProductEntity } from "../../entity_types/product";

export const p_cuhq8quqvw: FaireProductEntity = {
  token: "p_cuhq8quqvw",
  type: "product",
  name: "Temperament Evil Eye & Pearl Charm Dangle Earrings",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/a68cfacd227f70b6d26c13baaae3b7dfc61a6357e26aba30de8d896215e91634.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd6f8bfd7bc1efa379d31f4513a5008f98143e3b82f872c704c4f18e67a6fb62.jpeg",
    "https://cdn.faire.com/fastly/a44bb7feab554a284909023a33c82f1406ff60ef03a3b34588d0dc0af7a619eb.jpeg",
    "https://cdn.faire.com/fastly/397b5b63805adc9fdd293a8e82a4e5d57fe14b5bc00b9ebcbb5a939291082e78.jpeg",
  ],
  priceDollars: 9.52,
  description:
    "Type: earrings\n\nMaterial : Copper，Resin ,Synthetic pearls，Gold plated\n\nSize : 35mm*57mm\n\n\n★Made of high quality material, Nickel-free / Lead-free， Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 25.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:41.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
